import { render, staticRenderFns } from "./SubscriptionsOverview.vue?vue&type=template&id=620f5e45&scoped=true&"
import script from "./SubscriptionsOverview.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsOverview.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsOverview.vue?vue&type=style&index=0&id=620f5e45&prod&lang=scss&scoped=true&"
import style1 from "./SubscriptionsOverview.vue?vue&type=style&index=1&id=620f5e45&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f5e45",
  null
  
)

export default component.exports